import { style } from '@vanilla-extract/css';
import { radiusVars, spacingVars } from '@tundr/ds-foundations';
import { semanticTokenVars } from '@tundr/ds-tokens';
import { themeVars } from '@tundr/theme';

const MODAL_WIDTH_PX = 584;

export const modalBackgroundClass = style({
  position: 'fixed',
  inset: 0,
  zIndex: themeVars.zIndex.modal_background,
  width: '100%',
  height: '100%',
  backgroundColor: semanticTokenVars.surface.overlay.backdrop,
  display: 'grid',
  placeItems: 'center',
});

export const modalContainerClass = style({
  outline: 'none' + '!important',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  width: MODAL_WIDTH_PX,
  maxWidth: '90vw',
  minHeight: 250,
  maxHeight: '90vh',
  zIndex: themeVars.zIndex.modal,
  backgroundColor: semanticTokenVars.surface.background.neutral.default.base,
  padding: `${spacingVars.xl} ${spacingVars.none}`,
  borderRadius: radiusVars.xl,
  border: 'none',
});

export const modalContainerWithCloseClass = style({
  paddingTop: `calc(${spacingVars.xl} + ${spacingVars['2xl']})`,
});

export const closeModalButtonClass = style({
  position: 'absolute',
  top: spacingVars.md,
  right: spacingVars.md,
});
